<div>
  <section >
    <div class="wrapper">
    <div class="styled-input">
    <label class="diagnostic-label">T.N.M Classification</label>
    <button type="button" class="add-boutton" (click)="openDialog()" style="left: 420px;" name="Add">Add</button>

    </div>
</div>
</section>
<BR>
  <BR>
  <section style="top: 350px;">
    <table >
      <tr>
        <td style="font-weight: bold;width: 90%;" >{{digdate}}    Dr. Mohamed Fathy</td>
        <td></td>
        <td><button type="button" (click)="openDialog()" class="fa fa-pencil" style="left: 400px;border-style: none;background-color: white;color: green;" matTooltip="Edit" name="Add" ></button></td>
        <td><button type="button" class="fa fa-trash" style="left: 350px;border-style: none;background-color: white;color: red;" matTooltip="Delete" name="Delete"></button></td>

      </tr>
      <tr>
        <td hidden="true">{{digdate}}</td>

        <td>Family :{{wk_Family}} T :{{Wk_T}}  N :{{Wk_N}}  M :{{Wk_M}}</td>
        <td ></td>
        <td ></td>
        <td ></td>
      </tr>

    </table>
  </section>


